module.exports = __webpack_public_path__ + "static/media/1.4 Vinckboons Kittung klein.302f86c0.jpg";